import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonDirectivesModule } from './directives';
import { MaterialComponentsModule } from './material-components.module';
import { CommonAuthService } from './services/auth.service';
import { InputFieldComponent } from './components/input-fields/input-field/input-field.component';
import { TextAreaComponent } from './components/input-fields/text-area/text-area.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MyRouter } from './services/router.service';
import { PasswordInputFieldComponent } from './components/input-fields/password-input-field/password-input-field.component';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { UnitInputFieldComponent } from './components/input-fields/unit-input-field/unit-input-field.component';
import { SelectComponent } from './components/selects/select/select.component';
import { DateTimeInputFieldComponent } from './components/input-fields/date-time-input-field/date-time-input-field.component';
import { NumberInputFieldComponent } from './components/input-fields/number-input-field/number-input-field.component';
import { ItemLoaderComponent } from './components/item-loader/item-loader.component';
import { CommonPipeModule } from './pipes';
import { CounterInputFieldComponent } from './components/counter-input-field/counter-input-field.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
        CommonDirectivesModule,
        MaterialComponentsModule,
        MatPasswordStrengthModule,
        CommonPipeModule,
        InputFieldComponent,
        UnitInputFieldComponent,
        PasswordInputFieldComponent,
        TextAreaComponent,
        LoaderComponent,
        SelectComponent,
        DateTimeInputFieldComponent,
        NumberInputFieldComponent,
        ItemLoaderComponent,
        CounterInputFieldComponent
    ],
    exports: [
        CommonModule,
        TranslateModule,
        CommonDirectivesModule,
        MaterialComponentsModule,
        InputFieldComponent,
        NumberInputFieldComponent,
        UnitInputFieldComponent,
        PasswordInputFieldComponent,
        TextAreaComponent,
        LoaderComponent,
        SelectComponent,
        DateTimeInputFieldComponent,
        ItemLoaderComponent,
        CommonPipeModule,
        CounterInputFieldComponent
    ],
    providers: [
        CommonAuthService,
        MyRouter
    ]
})
export class CommonLogicModule {}
